'use strict';

angular.module('app.manualPosts', [])
    .controller('manualPostsCtrl', ['$scope', '$modal', 'adminService', 'manualPostsService',
        function ($scope, $modal, adminService, manualPostsService) {

            $scope.today = function() {
                $scope.dt_publishDate = moment().format('DD-MM-YYYY');
            };
            $scope.today();

            $scope.clear = function () {
                $scope.dt_publishDate = null;
            };

            // Disable weekend selection
            $scope.disabled = function(date, mode) {
                return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
            };

            $scope.toggleMin = function() {
                $scope.minDate = $scope.minDate ? null : new Date();
            };
            $scope.toggleMin();

            $scope.openPublishDate = function($event,option) {
                $event.preventDefault();
                $event.stopPropagation();

                $scope.openedPublishDate = true;
            };
            $scope.dateOptions = {
                formatYear: 'yy',
                startingDay: 1
            };

            $scope.formats = ['dd-MM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'DD-MM-YYYY', 'shortDate'];
            $scope.format = $scope.formats[0];

            $scope.preLoaded = false;
            $scope.currentPage = 1;
            $scope.pageSize = 25;
            $scope.hasValue = null;

            //server-side
            $scope.preLoadData = function(hasValue, flag){
                if(hasValue == null){
                    var params = {
                        pageNo: $scope.currentPage
                    }

                    $scope.sendHttpPOST(params);
                }
                $scope.preLoaded = true;
            }

            $scope.sendHttpPOST = function(params){
                manualPostsService.getManualPosts(params, true)
                    .then(function(response) {
                        $scope.posts = response.data;
                        $scope.number = response.totalRow;
                        $scope.pagination();
                    }, function(response){
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            if(!$scope.preLoaded){
                $scope.preLoadData($scope.hasValue);
            }

            $scope.pagination = function(){
                $scope.pages = adminService.pagination($scope.number, $scope.pageSize);
            };

            $scope.updatePage = function(val,flag){
                $scope.currentPage = val;
                var params = {
                    pageNo: $scope.currentPage
               } 

               $scope.sendHttpPOST(params);
            }

            $scope.addManualPost = function () {
                var day = moment.duration(moment() - $scope.dt_publishDate).days();
                $scope.dt_publishDate = moment().subtract(day, 'days').format('YYYY-MM-DD');
                var params = {
                    url: $scope.postURL,
                    published_date: $scope.dt_publishDate
                }

                manualPostsService.addManualPost(params, true) 
                    .then(function(response) {
                        location.reload('admin/manualPosts');
                    }, function(response) {
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }   
}])